
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageCarousel } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'update:altText', 'update:validateValue'],
})
export default class Carousel extends Vue {
  @Prop()
  modelValue!: IFlexMessageCarousel

  @Prop()
  altText!: string

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  get currentAltText() {
    return this.altText
  }

  set currentAltText(value: string) {
    this.$emit('update:altText', value)
  }

  get requiredRule() {
    return {
      altText: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.answer.alt_text'),
      }),
    }
  }

  get typeList() {
    return [
      {
        label: 'カルーセル',
        value: 'carousel',
      },
      {
        label: 'バブル',
        value: 'bubble',
      },
    ]
  }

  @Watch('currentAltText', { immediate: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    this.validate()
  }
}
